<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.areaId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <a-switch
        slot="memberStatus"
        checked-children="正常"
        un-checked-children="关闭"
        default-checked
        @change="onChange"
      />
      <template slot="operate" slot-scope="text, operate">
        <a v-on:click.prevent="showModal(operate)">奖罚</a>
      </template>
    </a-table>
    <a-modal
      v-model="visible"
      title="奖罚"
      @ok="handleOk"
      :maskStyle="{ opacity: 0.1 }"
      cancelText="取消"
      okText="确定"
    >
      <p>名称：{{ name }}</p>
      <p>
        奖罚：
        <a-radio-group
          name="radioGroup"
          :default-value="true"
          v-model="jsons.add"
        >
          <a-radio :value="true">奖励</a-radio>
          <a-radio :value="false">付款，扣款</a-radio>
        </a-radio-group>
      </p>
      <p>
        金额：
        <a-input
          style="width: 150px"
          v-model="jsons.money"
          placeholder="金额不能为空"
        />
      </p>
      <p>
        奖罚原因：<a-textarea
          v-model="jsons.reason"
          placeholder="Basic usage"
          :rows="4"
        />
      </p>
    </a-modal>
  </div>
</template>
<script>
import { storesList, storesListSeach } from "@/api/homeApi.js";
import { userPrizePenalty } from "@/api/userApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "用户uid",
    dataIndex: "gender",
  },
  {
    title: "手机号",
    dataIndex: "phone",
  },
  {
    title: "昵称",
    dataIndex: "name",
    sorter: true,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "用户状态",
    dataIndex: "name",
    sorter: true,
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "门店余额",
    dataIndex: "balance",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "balance" },
  },
  {
    title: "操作",
    dataIndex: "name",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      name: "",
      value: "1",
      loading: false,
      columns,
      jsons: {
        add: "",
        money: "",
        reason: "",
        userType: "1501",
        objId: "",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      visible: false,
    };
  },
  mounted() {
    this.getStoresListData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getStoresListData() {
      storesList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storesList({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    query() {
      storesListSeach(10, 1, this.formInline.name, this.formInline.phone).then(
        (res) => {
          this.pagination.total = res.count;
          this.data = res.data;
        }
      );
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal(row) {
      console.log(row);
      this.visible = true;
      this.jsons.objId = row.objId;
      this.name = row.name;
    },
    handleOk() {
      this.visible = false;
      userPrizePenalty(this.jsons).then((res) => {
        message.success(res.info);
        this.getStoresListData();
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/financialManagement/storeBalance/storeBalanceContent.vue